import cleanedFilename from '~/util/cleanedFilename';

export default {
  DELETE_BUTTON: `${cleanedFilename(__filename)}-delete-button`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
